import React, {useEffect} from 'react';
import {checkNullStr} from "../utils/ReactUtils";

const NullMsgLabel = React.memo(({
                                     className = '',
                                     color = '',
                                     textAt = 'center',
                                     children,
                                 }) => {
    const TAG = "NullMsgLabel";

    useEffect(() => {

    }, []);
    useEffect(() => {

    }, [children]);

    return (checkNullStr(children) && <label
        className={`mt-2 px-1 text-darkx fw-normal text-center-forcex d-flex w-100 text-${textAt} jc-${textAt} ${className}`}
        style={{color: color}}>
        {children}
    </label>)

});
export default NullMsgLabel;
